
import gsap from "gsap";
import { AnimationAction, AnimationMixer, Color, DataTexture, DoubleSide, Group, LoopOnce, Mesh, MeshLambertMaterial, MeshPhongMaterial, MeshStandardMaterial, TextureLoader, sRGBEncoding } from "three";
import { config } from "./utils/config";
import { LoadedGLTFs } from "../../utils/types";
import { GLTF } from "three/examples/jsm/loaders/GLTFLoader";
import { Params } from "../../../utils/types";

export class SharpiePack {
    public instance: Group;
    private pack: GLTF["scene"];
    private placeholders: Array<Mesh>;
    private pens: Array<Mesh | Group>;
    private plastic!: Mesh;
    private action!: AnimationAction;
    private envMap: DataTexture;

    private urlParams: Params;

    private params: keyof typeof config

    private sharpieTextureFront: string;
    private sharpieTextureLabel: string;

    private declare mixer: AnimationMixer | null;
    constructor(gltfs: LoadedGLTFs, envMap: DataTexture, urlParams: Params) {
        this.instance = new Group;
        console.log(gltfs.pack)
        this.pack = gltfs.pack.scene;
        this.pens = [];
        this.placeholders = [];
        this.envMap = envMap;

        this.urlParams = urlParams;
        this.params = this.urlParams.penType + this.urlParams.penNum as keyof typeof config;

        this.sharpieTextureFront = 'https://ddg67ecygv8rc.cloudfront.net/sharpie/sharpiePackTextures/' + urlParams.penNum + 'Pack_' + urlParams.packType + '_' + urlParams.penType + '_' + 'front.png';
        this.sharpieTextureLabel = 'https://ddg67ecygv8rc.cloudfront.net/sharpie/sharpiePackTextures/' + urlParams.penNum + 'Pack_' + urlParams.penType + '_label_' + urlParams.packType + '.png';


        // console.log('frontPack', this.sharpieTextureFront)
        // console.log('backPack', this.sharpieTextureBack)
        console.log('labelPack', this.sharpieTextureLabel)

        console.log(gltfs)
        let penGltf = urlParams.penType == 'brush' ? gltfs.pen_brush : gltfs.pen_bullet
        this.setUpPens(penGltf)
        this.setUpSharpiePack();
        this.createAnimations(gltfs.pack);

    }

    public setUpSharpiePack() {
        let scale = config[this.params].packGlbScale;
        let pos = config[this.params].packGlbPos;

        this.instance.visible = false;
        this.instance.scale.set(scale[0], scale[1], scale[2])
        this.instance.position.set(pos[0], pos[1], pos[2])
        this.instance.rotation.set(0, -Math.PI / 2, 0)

        this.pack.traverse((node: object) => {
            if (node instanceof Mesh) {
                if (node.name.includes('plastic')) {
                    this.plastic = node;
                    let texture = new TextureLoader().load(this.sharpieTextureLabel);

                    let metalnessMap = node.material.metalnessMap;
                    texture.encoding = sRGBEncoding;
                    texture.flipY = false;

                    this.plastic.material = new MeshStandardMaterial({
                        map: texture,
                        roughness: 0,
                        metalness: 1,
                        metalnessMap: metalnessMap,
                        transparent: true,
                        opacity: 1,
                        envMap: this.envMap,
                        envMapIntensity: 1,
                        depthWrite: false,
                        depthTest: false,
                        side: DoubleSide,
                    });
                    this.plastic.renderOrder = 1;
                }
                else {

                    let texture = node.material.map;

                    node.material = new MeshLambertMaterial({ map: texture })

                    if (node.name.includes('Placeholder')) {

                        this.placeholders.push(node);
                        node.visible = false
                    }
                    else if (node.name.includes('Front') || node.name.includes('front')) {
                        if (this.urlParams.packType != 'new') {
                            let texture = new TextureLoader().load(this.sharpieTextureFront)
                            texture.encoding = sRGBEncoding;
                            texture.flipY = false;
                            node.material = new MeshLambertMaterial({ map: texture })
                        }
                    }
                }
                node.material.transparent = true;
            }
            this.instance.add(this.pack);
        })
    }

    public setUpPens(gltf: GLTF) {
        let colours = config[this.params].penColours;
        for (let i = 0; i < this.urlParams.penNum; i++) {
            let penGroup = new Group;
            let pen = gltf.scene.clone()
            let penScale = config[this.params].penScale;
            pen.scale.set(penScale[0], penScale[1], penScale[2])
            pen.rotation.set(Math.PI / 2, -Math.PI / 2, 0)
            pen.renderOrder = 0;
            pen.traverse(function (node: object) {
                if (node instanceof Mesh) {
                    node.material.transparent = true;
                    let material = node.material.map;
                    node.material = new MeshPhongMaterial({ map: material });
                    if (node.name == "nib" || node.name == "body_2" || node.name == "bottom" || node.name == "coloured_part") {
                        node.material = new MeshLambertMaterial({ color: new Color(colours[i]).convertSRGBToLinear() });
                    }
                }
            });
            penGroup.add(pen)
            this.instance.add(penGroup);
            this.pens.push(penGroup);
        }
    }

    private createAnimations = (gltf: GLTF) => {
        this.mixer = new AnimationMixer(gltf.scene);
        this.mixer.timeScale = 0.45;
        let anims = gltf.animations;
        this.action = this.mixer.clipAction(anims[0]);
        this.action.clampWhenFinished = true;
        this.action.setLoop(LoopOnce, 1);
    };

    public playAnimation = () => {
        this.instance.visible = true;
        return new Promise<void>((resolve, _) => {
            this.action.play();
            this.mixer?.addEventListener("finished", onLoopFinished);
            function onLoopFinished() {
                console.log('animation complete')
                resolve()
            }
        })
    }

    public hidePensAndPlastic = () => {
        this.pens.forEach(pen => {
            pen.visible = false;
        });
        if (this.plastic != null)
            this.plastic.visible = false;
    }

    // public fadeOutAnimation = () => {
    //     return new Promise<void>((resolve, _) => {
    //         this.pack.traverse((node: object) => {
    //             if (node instanceof Mesh && node.visible == true) {
    //                 gsap.to(node.material, {
    //                     opacity: 0,
    //                     duration: 0.5,
    //                     ease: "sine.easeOut",
    //                     onComplete: () => {
    //                         if (this.pack != null)
    //                             this.pack.visible = false;
    //                         resolve()
    //                     },
    //                 });
    //             }
    //         });
    //     })
    // }

    public hide = () => {
        this.instance.visible = false;
    }


    update = (delta: number) => {
        if (this.mixer) this.mixer.update(delta);
        let penPos = config[this.params].penPos;

        this.placeholders.forEach((placeholder, i) => {
            if (this.pens[i] != null) {
                this.pens[i].position.set(placeholder.position.x + penPos[0], placeholder.position.y - (i * 0.0016) + penPos[1], placeholder.position.z + penPos[2])
                this.pens[i].quaternion.copy(placeholder.quaternion)
            }
        });
    };
}
